// Hook - seria czasowa sprzedazy ofert ACCEPTED per miesiac.
// GET /api/ui/trader-management/sales-timeseries

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IGetSalesTimeseriesParams,
  IGetSalesTimeseriesResponse,
} from 'api/types/traderManagement';

const getTraderManagementSalesTimeseries = (
  params: IGetSalesTimeseriesParams
): Promise<IGetSalesTimeseriesResponse> =>
  axios.get('/trader-management/sales-timeseries', { params });

export const useGetTraderManagementSalesTimeseries = (
  params: IGetSalesTimeseriesParams = {},
  options?: UseQueryOptions<IGetSalesTimeseriesResponse, IError>
) =>
  useQuery<IGetSalesTimeseriesResponse, IError>(
    ['trader-management-sales-timeseries', params],
    () => getTraderManagementSalesTimeseries(params),
    { keepPreviousData: true, ...(options ?? {}) }
  );
